import React from 'react'
import * as UI from 'ui'
import SellShift from 'support/actions/shifts/SellShift'
import BuyShift from 'support/actions/shifts/BuyShift'
import ExchangeShift from 'support/actions/shifts/ExchangeShift'
import { useValue } from '@morningtrain/react-resources'

export default function ExchangeActionsInner ({ fullWidth = true, className }) {
  const isOnSale = useValue('is_on_sale')
  const slotId = useValue('id')
  const availableExchangeActions = useValue('available_exchange_actions')
  const exchangeId = useValue('buyable_exchange_id')

  return (
    <UI.ButtonWrap leftAlign className={className}>
      {(availableExchangeActions && availableExchangeActions.includes('sell'))
        ? (
          <SellShift fullWidth={fullWidth} slotId={slotId} />
          )
        : null}
      {(availableExchangeActions && availableExchangeActions.includes('buy'))
        ? (
          <BuyShift fullWidth={fullWidth} slotId={slotId} isOnSale={isOnSale} />
          )
        : null}
      {(availableExchangeActions && availableExchangeActions.includes('exchange'))
        ? (
          <ExchangeShift fullWidth={fullWidth} slotId={slotId} exchangeId={exchangeId} />
          )
        : null}
    </UI.ButtonWrap>
  )
}
